import { all, takeEvery } from 'redux-saga/effects';

import {
  createAttachmentInCurrentSellitemService,
  createAttachmentProductService,
  deleteAttachmentService,
  handleAttachmentCreateService,
  handleAttachmentDeleteService,
  handleAttachmentUpdateService,
  updateAttachmentService,
} from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* attachmentWatchers() {
  yield all([
    takeEvery(EntryActionTypes.ATTACHMENT_IN_CURRENT_SELLITEM_CREATE, ({ payload: { data } }) =>
      createAttachmentInCurrentSellitemService(data),
    ),
    takeEvery(EntryActionTypes.ATTACHMENT_PRODUCT_CREATE, ({ payload: { data, uuid } }) =>
      createAttachmentProductService(data, uuid),
    ),
    takeEvery(EntryActionTypes.ATTACHMENT_CREATE_HANDLE, ({ payload: { attachment, requestId } }) =>
      handleAttachmentCreateService(attachment, requestId),
    ),
    takeEvery(EntryActionTypes.ATTACHMENT_UPDATE, ({ payload: { id, data } }) =>
      updateAttachmentService(id, data),
    ),
    takeEvery(EntryActionTypes.ATTACHMENT_UPDATE_HANDLE, ({ payload: { attachment } }) =>
      handleAttachmentUpdateService(attachment),
    ),
    takeEvery(EntryActionTypes.ATTACHMENT_DELETE, ({ payload: { id } }) =>
      deleteAttachmentService(id),
    ),
    takeEvery(EntryActionTypes.ATTACHMENT_DELETE_HANDLE, ({ payload: { attachment } }) =>
      handleAttachmentDeleteService(attachment),
    ),
  ]);
}
